<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>수험표 출력</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>수험표 출력</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="inform_box">
            <ol class="dot">
              <li class="color">
                <span class="ol_li_txt">
                  수험표 내 안내사항을 반드시 숙지하여 주시기 바라며, 시험당일
                  수험표와 신분증을 지참하여 시험장에 오시길 바랍니다.
                </span>
              </li>
            </ol>
          </div>
          <div class="table mt30">
            <div class="row head">
              <div class="cell fix150"><p>번호</p></div>
              <div class="cell"><p>제목</p></div>
              <div class="cell fix150"><p>접수일</p></div>
              <div class="cell fix150"><p>접수</p></div>
              <div class="cell fix180"><p></p></div>
            </div>
            <div class="page_con" v-if="$Util.isEmpty(items)">
              <div class="empty_wrap">
                <div class="empty">
                  <span>내역이 존재하지 않습니다.</span>
                </div>
              </div>
            </div>
            <div class="row" v-for="(item, index) in items" :key="index">
              <div class="cell fix150">
                <p>{{ pageInfo.virtualNum - index }}</p>
              </div>
              <div class="cell">
                <p class="left">
                  {{ item.exam.titleName }}
                </p>
              </div>
              <div class="cell fix150">
                <p>{{ $moment(item.userExam.regDate).format('YYYY.MM.DD') }}</p>
              </div>
              <div class="cell fix150"><p>입금확인</p></div>
              <div class="cell fix180">
                <button class="btn bo" @click="fnModal(item)">수험표 출력</button>
              </div>
            </div>
          </div>
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchData"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-admission-index',
  description: '수험표 출력',
  data() {
    return {
      params: {
        page: 1,
        limit: 10,
        examStatuses: ''
      },
      pageInfo: {},
      items: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.examStatuses = 2
      this.params.page = page
      const res = await this.$ManagerSvc.getListBoxUserExam(this.params)
      console.log('res', res)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnModal: function(item) {
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EXAM_ADMISSION_POPUP,
        data: { item: item, applyType: 2 },
        callBack: () => {}
      })
    }
  }
}
</script>

<style scoped></style>
